import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../AuthContext";
import { captureReferral, capturePostTrackingToken, saveReferralVisitId } from "../utils/referralAttribution";

export default function ReferralVisitTracker() {
  const location = useLocation();
  const { apiUrl } = useAuth();

  useEffect(() => {
    const attribution = captureReferral(location.search);
    capturePostTrackingToken(location.search);
    if (!attribution.ref) return;
    if (attribution.visitId) return;
    axios.post(`${apiUrl}/api/referrals/visits`, {
      ref: attribution.ref,
      visitor_id: attribution.visitorId,
      session_id: attribution.sessionId,
      path: location.pathname,
    }).then((response) => {
      if (response.data?.visit_id) saveReferralVisitId(response.data.visit_id);
    }).catch(() => {});
  }, [apiUrl, location.pathname, location.search]);

  return null;
}
